import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router';
// Protected Route Component
import { routes } from './config/routes';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import UnauthorizedPage from "./pages/unauthorized/UnauthorizedPage";
// Main App Component
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          
        {routes.map(({ path, element: Element, protected: isProtected, roles }) => (
            <Route
              key={path}
              path={path}
              element={
                isProtected ? (
                  <ProtectedRoute allowedRoles={roles}>
                    <Element />
                  </ProtectedRoute>
                ) : (
                  <Element />
                )
              }
            />
          ))}

        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;